import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMissions } from '../../store/slices/missionSlice';
import StandardMissionCard from './StandardMissionCard';

const RecentMissions = ({ limit = 3 }) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const { missions, isLoading } = useSelector(state => state.missions);
  const { user } = useSelector(state => state.auth);
  const [recentMissions, setRecentMissions] = useState([]);

  useEffect(() => {
    if (missions && missions.length > 0) {
      // Ordenar por fecha de creación y limitar
      const sorted = [...missions]
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .slice(0, limit);
      setRecentMissions(sorted);
    }
  }, [missions, limit]);

  const handleViewAll = () => {
    navigation.navigate('Missions');
  };

  const handleMissionPress = (mission) => {
    // Navegar directamente a la pestaña de detalle de misión
    navigation.navigate('MissionDetailTab', {
      screen: 'MissionDetail',
      params: { missionId: mission.id }
    });
  };

  // Si no hay misiones y no está cargando, mostrar mensaje
  if (!isLoading && (!missions || missions.length === 0)) {
    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title}>{'Misiones Recientes'}</Text>
          <TouchableOpacity onPress={handleViewAll}>
            <Text style={styles.viewAll}>{'Ver todas'}</Text>
          </TouchableOpacity>
        </View>
        <Text style={styles.emptyText}>{'No hay misiones disponibles'}</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>{'Misiones Recientes'}</Text>
        <TouchableOpacity onPress={handleViewAll}>
          <Text style={styles.viewAll}>{'Ver todas'}</Text>
        </TouchableOpacity>
      </View>

      {recentMissions.length === 0 ? (
        <Text style={styles.loadingText}>{'Cargando...'}</Text>
      ) : (
        <View style={styles.missionsContainer}>
          {recentMissions.map(mission => {
            return (
              <StandardMissionCard
                key={mission.id}
                mission={mission}
                onPress={() => handleMissionPress(mission)}
                compact={false}
                user={user}
              />
            );
          })}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 15,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  viewAll: {
    color: '#3498db',
    fontSize: 14,
  },
  loadingText: {
    textAlign: 'center',
    color: '#7f8c8d',
    padding: 20,
  },
  emptyText: {
    textAlign: 'center',
    color: '#7f8c8d',
    padding: 20,
  },
  missionsContainer: {
    flex: 1,
    paddingHorizontal: 0,
  }
});

export default RecentMissions;